module.exports = __webpack_public_path__ + "img/terminal-promo.bfa3d46d.png";